import Freja1 from '../../media/Freja/freja (1).png'
import Freja2 from '../../media/Freja/freja (2).png'

const images =[
    Freja1,Freja2
]

export default images;